import $ from 'jquery';
import _ from 'underscore';
import Youtubeplayer from 'picnic/Youtubeplayer';
import {i18next} from 'picnic/core/utils/i18next';


const
	CLASS_BUTTON = 'has-button',
	CLASS_PLAYING = 'is-playing',
	TEXT_PAUSE = i18next.t('Pause'),
	TEXT_PLAY = i18next.t('Play'),
	TEMPLATE_BUTTON = `<button type="button"><span>${TEXT_PAUSE}</span></button>`
;


class View extends Youtubeplayer {

	constructor(options) {
		super(options);

		this._onClick = this._onClick.bind(this);
		this._onPlay = this._onPlay.bind(this);
	}

	render() {
		// Button
		this.$button = $(TEMPLATE_BUTTON);
		this.$el.append(this.$button);
		this.$el.closest('.content').addClass(CLASS_BUTTON);
		this.$button.on('click', this._onClick);

		// Video
		this.video = this.$el.find('video').get(0);
		if (this.video && this.video.autoplay) {
			// Lazy load video source
			if (this.$el.find('source[data-src]').length) {
				this._lazyResize = _.debounce(this._onResize, 200);
				$(window).on('resize orientationChange', () => this._lazyResize());
				this._onResize();
			}

			// Play
			this._autoplay();
			this._videoCounter = 0;
			this.video.addEventListener('playing', this._onPlay);
		}

		return this;
	}

	destroy() {
		if (this.$button && this.$button.length) {
			this.$button.off('click', this._onClick);
			this.$button.remove();
		}
	}

	play() {
		this.$el.addClass(CLASS_PLAYING);
		this.$button.children().text(TEXT_PAUSE);
		this._videoCounter = 0;
		return this.video.play();
	}

	stop() {
		this.$el.removeClass(CLASS_PLAYING);
		this.$button.children().text(TEXT_PLAY);
		this.video.pause();
	}

	_autoplay() {
		var promise = this.play();

		// https://webkit.org/blog/7734/auto-play-policy-changes-for-macos/
		if (promise !== undefined) {
			promise.catch(() => {
				// Auto-play was prevented
				this.$el.removeClass(CLASS_PLAYING);
			}).then(() => {
				// Auto-play started
			});
		}
	}

	_onClick(event) {
		event.preventDefault();

		if (!this.$el.hasClass(CLASS_PLAYING)) {
			this.play();
		} else {
			this.stop();
		}
	}

	_onPlay() {
		this._videoCounter++;

		if (this._videoCounter >= 4) {
			this.stop();
		}
	}

	_onResize() {
		const windowWidth = window.innerWidth || $(window).width();
		let load = false;

		this.$el.find('source').each((index, el) => {
			const
				$el = $(el),
				src = $el.attr('src'),
				dataSrc = (windowWidth <= 700) ? $el.data('src-mobile') : $el.data('src')
			;

			if (src !== dataSrc) {
				$el.attr('src', dataSrc);
				load = true;
			}
		});

		if (load) {
			this.video.load();
		}
	}
}

export default View;
